(() => {
  const colorOptionNames = new Set([
    'color',
    'colour',
    'leather color',
    'leather colour',
  ]);

  const selectButtonText = 'Select a color';
  const selectLabelText = 'Please select';

  const normalize = (value = '') =>
    value.trim().toLowerCase().replace(/\s+/g, ' ');

  function changeButtonText(button) {
    let textChanged = false;

    button.childNodes.forEach((node) => {
      if (
        node.nodeType === Node.TEXT_NODE &&
        node.textContent.trim() !== ''
      ) {
        node.textContent = ` ${selectButtonText} `;
        textChanged = true;
      }
    });

    if (!textChanged) {
      const addedIcon = button.querySelector('.add-to-cart__added');
      button.insertBefore(
        document.createTextNode(` ${selectButtonText} `),
        addedIcon
      );
    }

    button.setAttribute('aria-label', selectButtonText);
  }

  function initializePicker(picker) {
    if (picker.dataset.lorColorRequired === 'true') return;

    const url = new URL(window.location.href);

    // Keep a deliberately linked variant selected.
    if (url.searchParams.has('variant')) return;

    const colorRadios = Array.from(
      picker.querySelectorAll(
        'input[type="radio"][data-option-name]'
      )
    ).filter((input) =>
      colorOptionNames.has(normalize(input.dataset.optionName))
    );

    const colorSelect = Array.from(
      picker.querySelectorAll('select')
    ).find((select) => {
      const options = Array.from(select.options).filter((option) =>
        colorOptionNames.has(normalize(option.dataset.optionName))
      );

      return options.length > 1;
    });

    if (colorRadios.length < 2 && !colorSelect) return;

    const scope =
      picker.closest('.shopify-section, dialog, product-card') ||
      document;

    const productId = picker.dataset.productId;

    const productForm = scope.querySelector(
      `product-form-component[data-product-id="${productId}"]`
    );

    if (!productForm) return;

    picker.dataset.lorColorRequired = 'true';

    if (colorRadios.length > 1) {
      colorRadios.forEach((input) => {
        input.checked = false;
        input.removeAttribute('checked');
      });

      const fieldset = colorRadios[0].closest('fieldset');
      const valueLabel = fieldset?.querySelector(
        '.variant-option__swatch-value'
      );

      if (valueLabel) {
        valueLabel.textContent = selectLabelText;
      } else {
        const legend = fieldset?.querySelector('legend');

        if (legend) {
          const prompt = document.createElement('span');
          prompt.textContent = ` — ${selectLabelText}`;
          legend.appendChild(prompt);
        }
      }
    }

    if (colorSelect) {
      Array.from(colorSelect.options).forEach((option) => {
        option.removeAttribute('selected');
      });

      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = selectButtonText;
      placeholder.disabled = true;
      placeholder.selected = true;
      placeholder.setAttribute('selected', 'selected');

      colorSelect.prepend(placeholder);
    }

    const variantId = productForm.querySelector(
      'input[name="id"][ref="variantId"]'
    );

    if (variantId) {
      variantId.value = '';
    }

    productForm
      .querySelectorAll(
        'add-to-cart-component [ref="addToCartButton"]'
      )
      .forEach((button) => {
        button.disabled = true;
        changeButtonText(button);
      });

    productForm
      .querySelectorAll(
        '[ref="acceleratedCheckoutButtonContainer"]'
      )
      .forEach((container) => {
        container.hidden = true;
      });

    const stickyCart = scope.querySelector(
      `sticky-add-to-cart[data-product-id="${productId}"]`
    );

    if (stickyCart) {
      stickyCart.dataset.variantAvailable = 'false';

      const stickyButton = stickyCart.querySelector(
        '[ref="addToCartButton"]'
      );

      if (stickyButton) {
        stickyButton.disabled = true;
      }
    }
  }

  function initializeAll(root = document) {
    root
      .querySelectorAll('variant-picker[ref="mainVariantPicker"]')
      .forEach(initializePicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAll();
    });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();